<template>
    <div>
        <v-row>
            <v-col class="bradcrumb">
                <router-link :to="{name: 'eps-admin-home' }" class="root">
                    Dashboard
                </router-link>
                <span class="child">/ Push Role Links </span>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <br />
        <center class="heading">
            <h3>Push Role Links</h3>
        </center>
        <v-card class="box"><br><br>
        <v-row>
            <v-col cols="12" sm="4">
        <v-container fluid>
            <v-row>
                <v-col class="d-flex" cols="12">
                    <v-autocomplete solo :items="tclist" item-value="tid" item-text="name" label="Tenant" v-model="selected_tenant" @change="fetchorganization()"></v-autocomplete>
                </v-col>
            </v-row>
        </v-container>
            </v-col>
            <v-col cols="12" sm="4">
        <v-container fluid style="display: none;" id="orgdiv">
            <v-row>
                <v-col class="d-flex" cols="12">
                    <v-autocomplete solo :items="orglist" item-value="id" item-text="name" label="Organization" v-model="selected_org" @change="fetchrole()"></v-autocomplete>
                </v-col>
            </v-row>
        </v-container>
            </v-col>
            <v-col cols="12" sm="4">
        <v-container fluid style="display: none;" id="rolediv">
            <v-row>
                <v-col class="d-flex" cols="12">
                    <v-autocomplete solo :items="role_list" item-value="id" item-text="name" label="Role*" v-model="selected_role" @change="fetchpresentlinks()"></v-autocomplete>
                </v-col>
            </v-row>
        </v-container>
            </v-col>
        </v-row>
        <v-container fluid style="display: none;" id="btndiv">
        <v-row justify="center">
            <v-btn class="button" @click="pushlinks()" id="pushbtn">Push</v-btn>
        </v-row>
        </v-container>
        </v-card>
        <v-container fluid style="display: none;" id="linkdiv">
            <v-card>
                <v-card-title>
                    Role Links
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="present_rolelink_list" :search="search">
                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <v-container fluid style="display: none;" id="pushlinkdiv">
            <v-card>
                <v-card-title>
                    Pushed Role Links
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers1" :items="pushed_link_list" :search="search">
                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
            <v-card color="#4CAF50" dark>
                <v-card-text>
                    Please wait...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css";
    import axios from "axios";
    export default {
        data: () => ({
            search: "",
            tclist: "",
            message: "",
            loading: true,
            dialog_send: false,
            selected_tenant: "",
            selected_org: "",
            selected_role: "",
            orglist: "",
            role_list: "",
            present_rolelink_list: "",
            pushed_link_list: "",
            selected_org: "",
            master_status: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            headers: [
                { text: "Link Name", value: "linkname", sortable: true },
                { text: "Link", value: "link", sortable: true },
                { text: "Icon", value: "icon", sortable: true },
                { text: "Sort Order", value: "sort_order", sortable: true },
                { text: "Role", value: "role", sortable: true },
                { text: "Is Active", value: "isactive", sortable: true },
            ],
            headers1: [
                { text: "Link Name", value: "linkname", sortable: true },
                { text: "Link", value: "link", sortable: true },
                { text: "Icon", value: "icon", sortable: true },
                { text: "Sort Order", value: "sort_order", sortable: true },
                { text: "Role", value: "role", sortable: true },
                { text: "Is Active", value: "isactive", sortable: true },
            ],
        }),

        mounted() {
            const data = {
                //uid:this.username
            };
            axios
                .post("/SuperAdminMaster/startCopy")
                .then((res) => {
                    window.console.log(res);
                    if (res.data.msg == "200") {
                        this.tclist = res.data.tenants;
                        //this.domainpath=res.data.domainpath
                    } else {
                        this.message = res.data.msg;
                    }
                })
                .catch((error) => {
                    window.console.log("error:" + error);
                });
        },

        methods: {
            fetchorganization() {
                const data = {
                    tenantid: this.selected_tenant,
                };
                axios
                    .post("/SuperAdminMaster/fetchOrganization", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.orglist = res.data.org;
                            //this.orglist.name=res.data.org.name
                            document.getElementById("orgdiv").style.display = "block";
                            //this.domainpath=res.data.domainpath
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    });
            },
            fetchrole() {
                const data = {
                    tenantid: this.selected_tenant,
                    orgid: this.selected_org,
                };
                axios
                    .post("/SuperAdminMaster/fetchRole", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.role_list = res.data.role_list;
                            //this.orglist.name=res.data.org.name
                            document.getElementById("rolediv").style.display = "block";
                            //this.domainpath=res.data.domainpath
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    });
            },
            fetchpresentlinks() {
                const data = {
                    tenantid: this.selected_tenant,
                    orgid: this.selected_org,
                    roleid: this.selected_role,
                };
                //alert('status')
                axios
                    .post("/SuperAdminMaster/fetchPresentRolelinks", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.present_rolelink_list = res.data.present_rolelink_list;
                            //this.orglist.name=res.data.org.name
                            document.getElementById("linkdiv").style.display = "block";
                            document.getElementById("btndiv").style.display = "block";
                            //this.domainpath=res.data.domainpath
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    });
            },
            pushlinks() {
                this.dialog_send = true;
                const data = {
                    tenantid: this.selected_tenant,
                    orgid: this.selected_org,
                    roleid: this.selected_role,
                };
                //alert('status')
                axios
                    .post("/SuperAdminMaster/pushRoleLinks", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            if (res.data.flag == "CEOYES") {
                                this.pushed_link_list = res.data.pushed_role_links;
                                document.getElementById("linkdiv").style.display = "none";
                                document.getElementById("pushlinkdiv").style.display = "block";
                                this.dialog_send = false;
                                this.showSnackbar("#4caf50", "Role Links Pushed Successfully...");
                            } else {
                                document.getElementById("linkdiv").style.display = "block";
                                this.showSnackbar("error", "Role Links already present!!!");
                                this.dialog_send = false;
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.message = res.data.msg;
                            this.dialog_send = false;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    @media only screen and (max-width: 600px) {
        .flex {
            display: block;
        }
    }
</style>
